<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { MESSAGE_VARIABLES } from 'shared/constants/messages';
import { sanitizeVariableSearchKey } from 'dashboard/helper/commons';
import MentionBox from '../mentions/MentionBox.vue';

const props = defineProps({
  searchKey: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['selectVariable']);

const store = useStore();

const customAttributes = computed(
  () => store.getters['attributes/getAttributes']
);

const sanitizedSearchKey = computed(() => {
  return sanitizeVariableSearchKey(props.searchKey);
});

const standardAttributeVariables = computed(() => {
  return MESSAGE_VARIABLES.filter(variable => {
    return (
      variable.label.includes(sanitizedSearchKey.value) ||
      variable.key.includes(sanitizedSearchKey.value)
    );
  }).map(variable => ({
    label: variable.key,
    key: variable.key,
    description: variable.label,
  }));
});

const customAttributeVariables = computed(() => {
  return customAttributes.value.map(attribute => {
    const attributePrefix =
      attribute.attribute_model === 'conversation_attribute'
        ? 'conversation'
        : 'contact';

    return {
      label: `${attributePrefix}.custom_attribute.${attribute.attribute_key}`,
      key: `${attributePrefix}.custom_attribute.${attribute.attribute_key}`,
      description: attribute.attribute_description,
    };
  });
});

const items = computed(() => {
  return [
    ...standardAttributeVariables.value,
    ...customAttributeVariables.value,
  ];
});

const handleVariableClick = (item = {}) => {
  emit('selectVariable', item.key);
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    type="variable"
    :items="items"
    @mention-select="handleVariableClick"
  />
</template>
